import WithAndWithoutBrand from "./components/WithAndWithoutBrand"
import ReusableTitleDescription from "./components/ReusableTitleDescription"
import BrandWorldFactsSection from "./components/BrandWorldFactsSection"
import BrandWorldServiceCenter from "./components/BrandWorldServiceCenter"
import React, {useContext} from "react"
import DataContext from "../../context/DataContext"

function BrandInfoSection() {
	const {brandWorld} = useContext(DataContext)
	return (
		<section className="brand-info-section-container">
			<WithAndWithoutBrand />
			<div className="px-2">
				<ReusableTitleDescription
					styles2={{maxWidth: "658px", opacity: "0.6"}}
					title={brandWorld.factsSectionTitle}
					description={brandWorld.factsSectionDescription} />
			</div>
			<BrandWorldFactsSection />
			<BrandWorldServiceCenter />
		</section>
	)
}

export default BrandInfoSection
